import styled from 'styled-components'
import { mediaQueries } from '../../../providers/MediaQueryProvider'
import { HELPER_CLASS } from '../consts'

export const Container = styled.div`
  display: flex;

  ${mediaQueries.tablet} {
    flex-direction: row;
  }
`

export const Handle = styled.div`
  color: var(--text-primary);
  cursor: pointer;
  margin-left: var(--space-250);

  &:hover {
    color: var(--text-secondary);
  }

  ${mediaQueries.tablet} {
    margin-left: var(--space-400);
  }
`

export const DragHandle = styled(Handle)`
  cursor: move;
  cursor: grab;

  .${HELPER_CLASS} & {
    cursor: grabbing;
  }
`
